import React, { useEffect } from "react";
import "./Category.css";
import {  useNavigate } from "react-router-dom";

// Main banner
import categoryHero from "../Assets/background2.jpg";

// Gold images
import gold1 from "../Assets/gold1.jpg";
import gold2 from "../Assets/gold2.jpeg";
import gold3 from "../Assets/gold3.jpg";
import gold4 from "../Assets/goldE6.jpg";
import gold5 from "../Assets/goldA6.jpg";
import gold6 from "../Assets/goldB2.jpg";

// Silver images
import silver1 from "../Assets/silver1.jpg";
import silver2 from "../Assets/silver2.jpg";
import silver3 from "../Assets/silverR2.jpg";
import silver4 from "../Assets/silverE4.jpg";
import silver5 from "../Assets/silverA6.jpg";
import silver6 from "../Assets/silverB2.jpg";

// Wedding images
import wed1 from "../Assets/wedding1.jpg";
import wed2 from "../Assets/wedding2.jpg";
import wed3 from "../Assets/wed4.jpg";
import wed4 from "../Assets/wedding3.jpg";
import wed5 from "../Assets/wed7.jpg";
import wed6 from "../Assets/wed8.jpg";

const Category = () => {
    const navigate = useNavigate();

    // ⭐ Scroll to top when Category page loads
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // ⭐ Scroll to top on "See More" click + navigate
    const handleSeeMore = (path) => {
        window.scrollTo(0, 0);
        navigate(path);
    };

    const goldCollection = [gold1, gold2, gold3, gold4, gold5, gold6];
    const silverCollection = [silver1, silver2, silver3, silver4, silver5, silver6];
    const weddingCollection = [wed1, wed2, wed3, wed4, wed5, wed6];

    return (
        <div className="category-page">

            {/* 🌟 Hero Section */}
            <section className="category-hero">
                <img src={categoryHero} alt="Our Collection" className="category-hero-img" />
                <div className="category-overlay">
                    <div className="category-hero-card">
                        <h1>Our Collection</h1>
                    </div>
                </div>
            </section>

            {/* 💎 Gold Section */}
            <section className="category-section">
                <h2>Gold Collection</h2>
                <hr />
                <div className="category-grid">
                    {goldCollection.map((img, i) => (
                        <div className="category-item" key={i}>
                            <img src={img} alt={`Gold ${i + 1}`} />
                            <p>Elegant Gold Jewellery Design</p>
                        </div>
                    ))}
                </div>

                <button
                    className="see-more-btn"
                    onClick={() => handleSeeMore("/gold")}
                >
                    See More
                </button>
            </section>

            {/* Silver */}
            <section className="category-section">
                <h2>Silver Collection</h2>
                <hr />
                <div className="category-grid">
                    {silverCollection.map((img, i) => (
                        <div className="category-item" key={i}>
                            <img src={img} alt={`Silver ${i + 1}`} />
                            <p>Elegant Silver Jewellery Design</p>
                        </div>
                    ))}
                </div>

                <button
                    className="see-more-btn"
                    onClick={() => handleSeeMore("/silver")}
                >
                    See More
                </button>
            </section>

            {/* Wedding */}
            <section className="category-section">
                <h2>Wedding & Engagement</h2>
                <hr />
                <div className="category-grid">
                    {weddingCollection.map((img, i) => (
                        <div className="category-item" key={i}>
                            <img src={img} alt={`Wedding ${i + 1}`} />
                            <p>Elegant Wedding Jewellery Design</p>
                        </div>
                    ))}
                </div>

                <button
                    className="see-more-btn"
                    onClick={() => handleSeeMore("/wedding")}
                >
                    See More
                </button>
            </section>

        </div>
    );
};

export default Category;
